import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useHeader } from "./Invs/bill-template02/style";
import { useInvAF, useInvMain } from "../St/Reviews/UseStyle";

function HeaderAll(props) {

    const { Report, found, Noborder } = props;
    const styf = { fontWeight: "1400", fontSize: "0.9rem", color: "#000" };
    const stysub = { fontWeight: "bold", fontSize: "0.9rem", color: "#000" };
    const styfC = { fontWeight: "1200", fontSize: "0.9rem", color: "#000" };

    const classHeader = useHeader();
    const clasm = useInvMain();
    const clas = useInvAF();
    const Styleborder = { fontWeight: "bold", border: "solid 1px", borderRadius: "5px", fontFamily: "Amiri-Regular", marginLeft: "0cm" };
    const styleborderNo = { fontWeight: "bold", fontFamily: "Amiri-Regular", with:"100%"};

    return (
        <Grid item container
            justifyContent="center"
        >
            {found.header_img != null ? (
                (
                    <Grid container item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                        <div>
                            <ButtonBase>
                                {" "}
                                <img
                                    src={`data:image/jpeg;base64,${found.header_img}`}
                                    className={clas.headerImg}
                                    alt={found.nameA}
                                />{" "}
                            </ButtonBase>
                        </div>
                    </Grid>
                )
            ) : (
                <Grid item container xs={12} style={Styleborder}>
                    <Grid item xs={5} className={classHeader.leftHeaderen}>
                        <div style={styf}>{found.Disc1_header_en}</div>
                        <div style={stysub}>{found.Disc2_header_en}</div>
                        <div style={styfC}>{found.Disc3_header_en}</div>{" "}
                        <div style={styfC}>{found.Disc4_header_en}</div>{" "}
                    </Grid>
                    <Grid item xs={2} className={clasm.mincntr}>
                        <div>
                            <ButtonBase>
                                {" "}
                                <img
                                    src={`data:image/jpeg;base64,${found.Logo}`}
                                    className={clas.Hedlogo}
                                    alt={found.nameA}
                                />{" "}
                            </ButtonBase>
                        </div>
                    </Grid>


                    <Grid item xs={5} className={classHeader.rightHeaderar}>
                        <div style={styf}>{found.Disc1_header_ar}</div>{" "}
                        <div style={stysub}>{found.Disc2_header_ar}</div>
                        <div style={styfC}>{found.Disc3_header_ar}</div>{" "}
                        <div style={styfC}>{found.Disc4_header_ar}</div>{" "}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}
export default HeaderAll;